import { render, staticRenderFns } from "./GenericStoreBackedPagination.vue?vue&type=template&id=20483323"
import script from "./GenericStoreBackedPagination.vue?vue&type=script&lang=js"
export * from "./GenericStoreBackedPagination.vue?vue&type=script&lang=js"
import style0 from "./GenericStoreBackedPagination.vue?vue&type=style&index=0&id=20483323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports